import React, { useContext, useEffect } from "react";
import { Modal } from "antd";
import { useState } from "react";
import ModalHeaderLayout from "../../../layouts/ModalHeaderLayout";
import axios from "axios";
import { apiUrl } from "../../../config";
import { useTranslation } from "react-i18next";

const BodyTypeModalFront = ({
  modalOpen,
  setModalOpen,
  selectedRow,
  allData,
  rule,
  setRefreshPage,
  refreshPage
}) => {
  const { t } = useTranslation();
  const username = process.env.REACT_APP_USERNAME;
  const password = process.env.REACT_APP_SECRET_KEY;

  const [formData1, setFormData1] = useState({
    description: "",
  });
  // ZORUNLU ALAN UYARILARI İÇİN ERROR STATE VE DOĞRULAMA
  const [errors, setErrors] = useState({});

  // MODAL AÇILINCA HATALARI TEMİZLE
  useEffect(() => {
    if (modalOpen) {
      setErrors({});
    }
  }, [modalOpen, rule, selectedRow]);

  const isEmptyValue = (v) => {
    if (v === null || v === undefined) return true;
    if (typeof v === "string") return v.trim() === "";
    return false;
  };
  const validateForm = () => {
    const errs = {};
    if (isEmptyValue(formData1.description)) {
      errs.description = `${t("constraints.frontBodyType")} ${t("constraints.isRequired")}`;
    }
    return errs;
  };

  useEffect(() => {

    if (selectedRow && rule === "changeOrder") {
      setFormData1({
        description: selectedRow.description,
      });
    } else {

      setFormData1({
        description: "",
      });
    }
  }, [selectedRow, modalOpen]);

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1({ ...formData1, [name]: value });
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: undefined }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // SUBMIT'TE DOĞRULAMA: EKSİK ALANLAR İÇİN UYARI MESAJLARI GÖSTER
    const errs = validateForm();
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    const requestMethod = rule === "changeOrder" ? axios.put : axios.post;
    let requestData;

    if (rule === "changeOrder") {
      requestData = { ...formData1, id: selectedRow.id };
    }

    if (rule === "newOrder") {
      requestData = formData1;
    }

    requestMethod(`${apiUrl}${window.location.pathname === "/simulasyon" ? "/beta" : ""}/addFrontBodyMaterialType`,
      requestData, {
      headers: {
        Authorization: `Basic ${btoa(`${username}:${password}`)}`
      }
    }
    ).then(res => {
      if (res.status === 200) {
        setFormData1({
          description: "",
        });
        setModalOpen(false);
        setErrors({}); // BAŞARILI SUBMIT SONRASI HATALARI TEMİZLE
        setRefreshPage(!refreshPage);
      }
    })
      .catch(err => console.log(err))
  }
  return (
    <Modal
      title=<ModalHeaderLayout title={rule === "changeOrder" ? t("constraints.changeBodyType") : t("constraints.addFrontBodyType")} />
      open={modalOpen}
      footer={null}
      onOk={() => setModalOpen(false)}
      onCancel={() => {
        setModalOpen(false);
        setErrors({}); // KAPATIRKEN HATALARI TEMİZLE
      }}
      centered
      className=" mb-40"
    >
      <form className='bg-surface p-3 rounded-2xl shadow-2xl' onSubmit={handleSubmit}>
        <div className='grid '>
          <div>
            <label htmlFor="description">{t("constraints.frontBodyType")}</label>
            <input onChange={(e) => handleChange1(e)} type="text" name="description" value={formData1.description} className="bg-gray-200 rounded h-8 block w-full mt-1" />
            {errors.description && <div className="text-red-600 text-xs mt-1">{errors.description}</div>}
          </div>
        </div>

        <div>
          <button type="submit" className="bg-smartopt hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-10 w-full">{t("singularParameters.submit")}</button>

        </div>


      </form>
    </Modal>
  );
};

export default BodyTypeModalFront;

